/* TROPICO buy box: add to cart (with add-ons) and open the side cart, delivery estimate */
(function () {
  'use strict';

  var HE_MONTHS = ['בינואר', 'בפברואר', 'במרץ', 'באפריל', 'במאי', 'ביוני', 'ביולי', 'באוגוסט', 'בספטמבר', 'באוקטובר', 'בנובמבר', 'בדצמבר'];

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay(); // 5 = Friday, 6 = Saturday (Israeli weekend)
      if (day !== 5 && day !== 6) added++;
    }
    return d;
  }

  function fmt(d) { return d.getDate() + ' ' + HE_MONTHS[d.getMonth()]; }

  function initDelivery() {
    document.querySelectorAll('[data-tpc-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 7;
      var max = parseInt(el.getAttribute('data-max'), 10) || 14;
      var now = new Date();
      var a = addBusinessDays(now, min), b = addBusinessDays(now, max);
      var range = a.getMonth() === b.getMonth()
        ? 'בין ' + a.getDate() + ' ל-' + b.getDate() + ' ' + HE_MONTHS[b.getMonth()]
        : 'בין ' + fmt(a) + ' ל-' + fmt(b);
      el.querySelector('[data-tpc-range]').textContent = range;
      el.hidden = false;
    });
  }

  function showError(msg) {
    var wrap = document.querySelector('#kyro-buy .product-form__error-message-wrapper');
    if (!wrap) { console.error(msg); return; }
    wrap.querySelector('.product-form__error-message').textContent = msg;
    wrap.hidden = false;
  }

  function buyNow(form, btn) {
    var input = form.querySelector('[data-kyro-variant-input]');
    if (!input || !input.value) return;
    var items = [{ id: parseInt(input.value, 10), quantity: 1 }];
    form.querySelectorAll('[data-tpc-addon]:checked').forEach(function (cb) {
      items.push({ id: parseInt(cb.value, 10), quantity: 1 });
    });
    var buttons = document.querySelectorAll('[data-tpc-direct]');
    buttons.forEach(function (b) { b.disabled = true; b.classList.add('loading'); });

    var drawer = document.querySelector('cart-drawer');
    var canDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var payload = { items: items };
    if (canDrawer) {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || 'שגיאה');
        buttons.forEach(function (b) { b.disabled = false; b.classList.remove('loading'); });
        if (canDrawer && res.body.sections) {
          var first = res.body.items && res.body.items[0];
          res.body.id = first ? first.variant_id : items[0].id;
          res.body.key = first ? first.key : undefined;
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          drawer.renderContents(res.body);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        buttons.forEach(function (b) { b.disabled = false; b.classList.remove('loading'); });
        showError('לא הצלחנו להוסיף את ההזמנה. נסו שוב. ' + (err && err.message ? '(' + err.message + ')' : ''));
      });
  }

  function initDirect() {
    var form = document.getElementById('kyro-product-form');
    var atc = document.querySelector('[data-kyro-atc][data-tpc-direct]');
    if (!form || !atc || form.dataset.tpcBound) return;
    form.dataset.tpcBound = '1';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      buyNow(form, atc);
    });

    // Sticky bar button buys directly instead of scrolling
    document.addEventListener('click', function (e) {
      var sticky = e.target.closest && e.target.closest('[data-kyro-sticky-btn][data-tpc-direct]');
      if (!sticky) return;
      e.preventDefault();
      e.stopPropagation();
      buyNow(form, sticky);
    }, true);
  }

  function boot() {
    initDelivery();
    initDirect();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
